import { render, staticRenderFns } from "./ApplyEdit.vue?vue&type=template&id=38161c0a"
import script from "./ApplyEdit.vue?vue&type=script&lang=js"
export * from "./ApplyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports